<template>
    <NuxtLayout>
        <div id="topBanner"></div>
        <NuxtPage />
    </NuxtLayout>
</template>

<style lang="postcss">
@import '~/assets/css/tailwind.css';

@import '~/assets/css/global.css';
@import '@nuxt-monorepo/base/app/assets/css/animations.css';
@import '@nuxt-monorepo/base/app/assets/css/richtext.css';
</style>
